import React from 'react';
import { BarChart, Bar, ResponsiveContainer } from 'recharts';

export default function SalesChart({
  row,
  scolor,
  pcolor,
  dcolor,
  acolor = '#555',
  height,
}: any) {
  const totalinvoiced = row?.totalinvoiced;
  const totalpaid = row?.totalpaid;
  const amount = row?.amount;

  const data = [
    {
      name: 'Sales',
      totalinvoiced: totalinvoiced || 0,
      totalpaid: totalpaid || 0,
      amount: amount || 0,
    },
  ];
  const h = height ? height : 100;
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        width={h * 0.8}
        height={h}
        data={data}
        margin={{
          top: 10,
          right: 5,
          left: 0,
          bottom: 10,
        }}
      >
        <Bar dataKey="amount" fill={acolor} />
        <Bar dataKey="totalinvoiced" fill={scolor} />
        <Bar dataKey="totalpaid" fill={pcolor} />
      </BarChart>
    </ResponsiveContainer>
  );
}
